// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formSection {
  color: #171717;
  padding-bottom: 15px;
  font-size: 500;
}

.scrollable-dropdown {
  max-height: 100px;
  overflow-y: auto;
}

.detailsInfoLabel {
  font-size: 16px;
  margin-top: 2%;
  margin-bottom: 1%;
  color: rgb(130, 139, 162);
  font-size: 15px;
  line-height: 18px;
}

.detailsInfoInput {
  border-radius: 3px;
  padding: 6px 10px;
  width: 95%;
  caret-color: rgb(26, 145, 240);
  background-color: rgb(239, 242, 249);
  outline: none;
  border: 0px;
  color: rgb(30, 37, 50);
  transition: color 0.1s ease 0s;
  margin-bottom: 4%;
}

.uplouploadPictureBigDiv {
  /* background-color: #cccccc; */
  position: relative;
}

.uplouploadPictureDiv {
  width: 20%;
  background-color: aqua;
  position: absolute;
}

.uploadPictureInput {
  background-color: none !important;
  width: 44% !important;
  padding-left: 5px;
  padding-right: 2px;
  position: absolute;
  /* top: 42%; */
  bottom: -21%;
  /* right: 8%; */
  left: 2% !important;
  font-size: 14px;
}

.uplouploadPhotoDivIcon {
  position: absolute;
  bottom: 10%;
  color: rgb(157, 165, 186);
  color: #5ec57e;
  z-index: 1;
  right: 35%;
}
.uplouploadPhotoDivGif {
  /* background-color: #171717; */
  position: absolute;
  top: -6%;
  color: rgb(157, 165, 186);
  color: #5ec57e;
  z-index: 1;
  right: 6%;
  height: 100px;
}

.uploadedPicture {
  z-index: 2;
  position: absolute;
  right: 20%;
  bottom: 15%;
}

.uplouploadPictureDivLabel {
  position: absolute;
  top: -20%;
  color: black;
  left: 2.2%;
  color: rgb(130, 139, 162);
  font-size: 15px;
  line-height: 18px;
}
.dottedDiv{
  position: absolute;
  border: 3px dotted #5ec57e; 
  z-index: 1;
  right: 4%;
  top: -87%;
  height: 130px;
  width: 44%;

}

.Sec1additionalDetails {
  background-color: white !important;
  border: white;
  text-align: left;
  width: 51%;
  display: block;
  color: rgb(26, 145, 240);
  font-weight: 500;
  margin-bottom: 3%;
}
.shiftedSec1additionalDetails{
  margin-top: 3.2%;
}

.detailsTextarea {
  border: 1px solid rgb(168, 177, 201);
  margin-top: 2%;
  font-size: 14px;
  padding: 1%;
  margin-bottom: 3%;
  width: 100%;
}

.detailsSubText {
  font-size: 14px;
  color: rgb(130, 139, 162);
  width: 99%;
}

.personalSubSubHeading {
  color: rgb(26, 145, 240);
  font-size: 18px;
  margin-bottom: 1.5%;
  margin-top: 2%;
}

.employmentHistoryDiv {
  position: relative;
}

.DeleteEmp {
  background-color: white;
  border: white;
  color: red;
  /* position: absolute; */
  /* bottom: -18px; */
  /* top:5%; */
  /* right: 3%; */
  margin-top: 0.5%;
  margin-bottom: 4%;
  margin-left: 95%;
}

.myAccordian {
  margin-bottom: 8%;
}
.webisteDiv{
  position: relative;
}

.DeleteSkill {
  background-color: white;
  border: white;
  color: rgb(148, 38, 38);
  /* color: goldenrod; */
}

.selectedOption {
  display: inline-block;
  margin-left: 0%;
  margin-right: 4%;
  padding-top: 3%;
}

.SkillsadditionalDetails {
  background-color: white !important;
  border: white;
  text-align: left;
  width: 51%;
  display: block;
  color: rgb(26, 145, 240);
  font-weight: 500;
  margin-bottom: 0%;
  margin-top: 2%;
}

.customSecMainHeading {
  /* margin-top: -8%; */
  margin-bottom: 6%;
}

.customSecDiv {
  margin-top: 15%;
}

.courseDescription {
  margin-bottom: 0;
  margin-top: 5%;
}
.customSecdetailsInfoLabel{
  margin-top: 0%;
}
.searchDetailsInfoInput{
  width: 80% !important;
}
.createLiveSearchDetailsInfoInput{
  width: 75%!important;
}
.addSkillBtn{
  background-color: white;
  border: none;
  margin-left: 2%;
  color: #347571;
  font-weight: 600;
}
.addExtraBtns{
  width: 100%;
  margin: 3%;
  margin-top: 0%;
  margin-bottom: 10%;
  color: #347571; 
  /* color: #5ec57e; */
  font-size: 18px;
}
.saveProfileDiv{
  position: relative;
  align-items: center;
  text-align: center;
  /* margin-bottom: -8%; */
}
.saveProfileBtn {
  margin: auto;
  margin-top: 4%;
  margin-bottom: 12%;
  width: 55%;
  border-radius: 5px;
  /* background-color: #c2fbd7; */
  background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
  border-radius: 25px;
  /* box-shadow: rgba(44, 187, 99, .2) 0 -25px 18px -14px inset, rgba(44, 187, 99, .15) 0 1px 2px, rgba(44, 187, 99, .15) 0 2px 4px, rgba(44, 187, 99, .15) 0 4px 8px, rgba(44, 187, 99, .15) 0 8px 16px, rgba(44, 187, 99, .15) 0 16px 32px;
  box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px; */
  color: rgb(255, 255, 255);
  cursor: pointer;
  display: inline-block;
  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;
  padding: 7px 20px;
  text-align: center;
  text-decoration: none;
  transition: all 250ms;
  border: 0;
  font-size: 14px;
  font-weight: 600;
  user-select: none;
  -webkit-user-select: none;
}

.saveProfileBtn:hover {
  background-color: #4F80FF;
  color: white;
  /* box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px; */
}
.createCustomAdditons{
  font-size: 16px;
}
.createCustomAdditons:hover{
  color: #5ec57e;
}
.moveBtnCreateUp{
  background-color: transparent;
  /* background-color: #346571; */
  border: none;
  text-align: right;
  position: absolute;
  top: -3% !important;
  width: 10%;
  right: 1% !important;

}
.moveBtnCreateDown{
  background-color: transparent;
  /* background-color: #346571; */
  border: none;
  text-align: right;
  position: absolute;
  top: 1.7%;
  width: 10%;
  right: 1% !important;
}
.moveBtnCreateWebsiteUp {
  background-color: transparent;
  /* background-color: #346571; */
  border: none;
  text-align: right;
  position: absolute;
  top: -46% !important;
  width: 10%;
  right: 2.5% !important;
}
.moveBtnCreateWebsiteDown {
  background-color: transparent;
  /* background-color: #346571; */
  border: none;
  text-align: right;
  position: absolute;
  top: -15.5%;
  width: 10%;
  right: 2.5% !important;
}
.moveBtnCreateNotLiveDown {
  background-color: transparent;
  /* background-color: #346571; */
  border: none;
  text-align: right;
  position: absolute;
  top: 8.5%;
  width: 10%;
  right: -2%;
}`, "",{"version":3,"sources":["webpack://./src/styleSheet/Form.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,8BAA8B;EAC9B,oCAAoC;EACpC,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,UAAU;AACZ;AACA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,UAAU;EACV,SAAS;EACT,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,UAAU;EACV,SAAS;EACT,SAAS;EACT,aAAa;EACb,UAAU;;AAEZ;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,wBAAwB;EACxB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,+BAA+B;EAC/B,kEAAkE;EAClE,mBAAmB;EACnB;6OAC2O;EAC3O,yBAAyB;EACzB,eAAe;EACf,qBAAqB;EACrB,8EAA8E;EAC9E,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,8OAA8O;AAChP;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;;AAEtB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;AACZ","sourcesContent":[".formSection {\n  color: #171717;\n  padding-bottom: 15px;\n  font-size: 500;\n}\n\n.scrollable-dropdown {\n  max-height: 100px;\n  overflow-y: auto;\n}\n\n.detailsInfoLabel {\n  font-size: 16px;\n  margin-top: 2%;\n  margin-bottom: 1%;\n  color: rgb(130, 139, 162);\n  font-size: 15px;\n  line-height: 18px;\n}\n\n.detailsInfoInput {\n  border-radius: 3px;\n  padding: 6px 10px;\n  width: 95%;\n  caret-color: rgb(26, 145, 240);\n  background-color: rgb(239, 242, 249);\n  outline: none;\n  border: 0px;\n  color: rgb(30, 37, 50);\n  transition: color 0.1s ease 0s;\n  margin-bottom: 4%;\n}\n\n.uplouploadPictureBigDiv {\n  /* background-color: #cccccc; */\n  position: relative;\n}\n\n.uplouploadPictureDiv {\n  width: 20%;\n  background-color: aqua;\n  position: absolute;\n}\n\n.uploadPictureInput {\n  background-color: none !important;\n  width: 44% !important;\n  padding-left: 5px;\n  padding-right: 2px;\n  position: absolute;\n  /* top: 42%; */\n  bottom: -21%;\n  /* right: 8%; */\n  left: 2% !important;\n  font-size: 14px;\n}\n\n.uplouploadPhotoDivIcon {\n  position: absolute;\n  bottom: 10%;\n  color: rgb(157, 165, 186);\n  color: #5ec57e;\n  z-index: 1;\n  right: 35%;\n}\n.uplouploadPhotoDivGif {\n  /* background-color: #171717; */\n  position: absolute;\n  top: -6%;\n  color: rgb(157, 165, 186);\n  color: #5ec57e;\n  z-index: 1;\n  right: 6%;\n  height: 100px;\n}\n\n.uploadedPicture {\n  z-index: 2;\n  position: absolute;\n  right: 20%;\n  bottom: 15%;\n}\n\n.uplouploadPictureDivLabel {\n  position: absolute;\n  top: -20%;\n  color: black;\n  left: 2.2%;\n  color: rgb(130, 139, 162);\n  font-size: 15px;\n  line-height: 18px;\n}\n.dottedDiv{\n  position: absolute;\n  border: 3px dotted #5ec57e; \n  z-index: 1;\n  right: 4%;\n  top: -87%;\n  height: 130px;\n  width: 44%;\n\n}\n\n.Sec1additionalDetails {\n  background-color: white !important;\n  border: white;\n  text-align: left;\n  width: 51%;\n  display: block;\n  color: rgb(26, 145, 240);\n  font-weight: 500;\n  margin-bottom: 3%;\n}\n.shiftedSec1additionalDetails{\n  margin-top: 3.2%;\n}\n\n.detailsTextarea {\n  border: 1px solid rgb(168, 177, 201);\n  margin-top: 2%;\n  font-size: 14px;\n  padding: 1%;\n  margin-bottom: 3%;\n  width: 100%;\n}\n\n.detailsSubText {\n  font-size: 14px;\n  color: rgb(130, 139, 162);\n  width: 99%;\n}\n\n.personalSubSubHeading {\n  color: rgb(26, 145, 240);\n  font-size: 18px;\n  margin-bottom: 1.5%;\n  margin-top: 2%;\n}\n\n.employmentHistoryDiv {\n  position: relative;\n}\n\n.DeleteEmp {\n  background-color: white;\n  border: white;\n  color: red;\n  /* position: absolute; */\n  /* bottom: -18px; */\n  /* top:5%; */\n  /* right: 3%; */\n  margin-top: 0.5%;\n  margin-bottom: 4%;\n  margin-left: 95%;\n}\n\n.myAccordian {\n  margin-bottom: 8%;\n}\n.webisteDiv{\n  position: relative;\n}\n\n.DeleteSkill {\n  background-color: white;\n  border: white;\n  color: rgb(148, 38, 38);\n  /* color: goldenrod; */\n}\n\n.selectedOption {\n  display: inline-block;\n  margin-left: 0%;\n  margin-right: 4%;\n  padding-top: 3%;\n}\n\n.SkillsadditionalDetails {\n  background-color: white !important;\n  border: white;\n  text-align: left;\n  width: 51%;\n  display: block;\n  color: rgb(26, 145, 240);\n  font-weight: 500;\n  margin-bottom: 0%;\n  margin-top: 2%;\n}\n\n.customSecMainHeading {\n  /* margin-top: -8%; */\n  margin-bottom: 6%;\n}\n\n.customSecDiv {\n  margin-top: 15%;\n}\n\n.courseDescription {\n  margin-bottom: 0;\n  margin-top: 5%;\n}\n.customSecdetailsInfoLabel{\n  margin-top: 0%;\n}\n.searchDetailsInfoInput{\n  width: 80% !important;\n}\n.createLiveSearchDetailsInfoInput{\n  width: 75%!important;\n}\n.addSkillBtn{\n  background-color: white;\n  border: none;\n  margin-left: 2%;\n  color: #347571;\n  font-weight: 600;\n}\n.addExtraBtns{\n  width: 100%;\n  margin: 3%;\n  margin-top: 0%;\n  margin-bottom: 10%;\n  color: #347571; \n  /* color: #5ec57e; */\n  font-size: 18px;\n}\n.saveProfileDiv{\n  position: relative;\n  align-items: center;\n  text-align: center;\n  /* margin-bottom: -8%; */\n}\n.saveProfileBtn {\n  margin: auto;\n  margin-top: 4%;\n  margin-bottom: 12%;\n  width: 55%;\n  border-radius: 5px;\n  /* background-color: #c2fbd7; */\n  background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n  border-radius: 25px;\n  /* box-shadow: rgba(44, 187, 99, .2) 0 -25px 18px -14px inset, rgba(44, 187, 99, .15) 0 1px 2px, rgba(44, 187, 99, .15) 0 2px 4px, rgba(44, 187, 99, .15) 0 4px 8px, rgba(44, 187, 99, .15) 0 8px 16px, rgba(44, 187, 99, .15) 0 16px 32px;\n  box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px; */\n  color: rgb(255, 255, 255);\n  cursor: pointer;\n  display: inline-block;\n  font-family: CerebriSans-Regular, -apple-system, system-ui, Roboto, sans-serif;\n  padding: 7px 20px;\n  text-align: center;\n  text-decoration: none;\n  transition: all 250ms;\n  border: 0;\n  font-size: 14px;\n  font-weight: 600;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.saveProfileBtn:hover {\n  background-color: #4F80FF;\n  color: white;\n  /* box-shadow: rgba(44, 187, 99, .35) 0 -25px 18px -14px inset, rgba(44, 187, 99, .25) 0 1px 2px, rgba(44, 187, 99, .25) 0 2px 4px, rgba(44, 187, 99, .25) 0 4px 8px, rgba(44, 187, 99, .25) 0 8px 16px, rgba(44, 187, 99, .25) 0 16px 32px; */\n}\n.createCustomAdditons{\n  font-size: 16px;\n}\n.createCustomAdditons:hover{\n  color: #5ec57e;\n}\n.moveBtnCreateUp{\n  background-color: transparent;\n  /* background-color: #346571; */\n  border: none;\n  text-align: right;\n  position: absolute;\n  top: -3% !important;\n  width: 10%;\n  right: 1% !important;\n\n}\n.moveBtnCreateDown{\n  background-color: transparent;\n  /* background-color: #346571; */\n  border: none;\n  text-align: right;\n  position: absolute;\n  top: 1.7%;\n  width: 10%;\n  right: 1% !important;\n}\n.moveBtnCreateWebsiteUp {\n  background-color: transparent;\n  /* background-color: #346571; */\n  border: none;\n  text-align: right;\n  position: absolute;\n  top: -46% !important;\n  width: 10%;\n  right: 2.5% !important;\n}\n.moveBtnCreateWebsiteDown {\n  background-color: transparent;\n  /* background-color: #346571; */\n  border: none;\n  text-align: right;\n  position: absolute;\n  top: -15.5%;\n  width: 10%;\n  right: 2.5% !important;\n}\n.moveBtnCreateNotLiveDown {\n  background-color: transparent;\n  /* background-color: #346571; */\n  border: none;\n  text-align: right;\n  position: absolute;\n  top: 8.5%;\n  width: 10%;\n  right: -2%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
